import { useEffect, useState } from "react";

export const useMap = () => {
    const [mapVersion,setMapVersion]: any = useState();

    useEffect(() => {
            setMapVersion(process.env.REACT_APP_MAP_VERSION)
        }, [])
    
    
    return mapVersion;
}